"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.categoryIds = exports.categoriesName = void 0;
exports.categoriesName = {
    correct: 'correct',
    incorrect: 'incorrect'
};
exports.categoryIds = { "correct": "5", "incorrect": "2" };
